import { type MutationError, trpc } from '@/shared/api';

interface UseSetCategoriesOptions {
  readonly onSuccess?: () => void;
}

/** 소분류 연결·대표 카테고리 저장. */
export const useSetCategories = ({ onSuccess }: UseSetCategoriesOptions = {}) => {
  const mutation = trpc.productManagement.products.setCategories.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    setCategories: mutation.mutate,
    isPending: mutation.isPending,
    error,
  };
};
